module.exports = __webpack_public_path__ + "media/rural-ga.ad6b87df.mp4";